/* ============================================================================
   RENKEISEN · assets/rk-home-vitrina.js                          14-09-2026
   "ese carrusel del inicio debe poder ir moviendose". El track ya se movia
   solo (transform animado por CSS), pero nadie podia moverlo con la mano:
   ni arrastrar, ni una flecha. Ademas, bajo prefers-reduced-motion el track
   se queda quieto a proposito (el movimiento es decorativo) y sin una forma
   manual de avanzar, esa persona no tenia como llegar a los productos 5 y 6
   — un hueco de accesibilidad real, no solo un gusto.

   Reemplaza la animacion CSS por un solo motor en JS (requestAnimationFrame)
   que escribe transform directamente: asi el auto-avance, el arrastre y las
   flechas leen y escriben la MISMA posicion, sin pelearse entre si (mezclar
   una @keyframes de CSS con transform puesto a mano desde JS hace que el
   navegador pise uno de los dos en cada frame, de forma inconsistente).

   El bucle infinito es el mismo truco de siempre: el track imprime el juego
   de tarjetas DOS VECES, y la posicion se normaliza en modulo sobre la mitad
   del ancho total, asi que nunca hay un salto visible.
   ============================================================================ */
(function () {
  'use strict';

  function iniciar(riel) {
    var track = riel.querySelector('[data-rk-vit-track]');
    if (!track) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var VELOCIDAD = reduceMotion ? 0 : 0.032; /* px por ms, ~misma cadencia que la animacion CSS anterior (42s por vuelta) */
    var PAUSA_TRAS_INTERACCION = 2600;

    var pos = 0;
    var mitadAncho = 0;
    var pausadoHover = false;
    var pausadoHasta = 0;
    var arrastrando = false;
    var arrastreInicioX = 0;
    var arrastrePosInicio = 0;
    var ultimoTs = null;

    function medir() {
      mitadAncho = track.scrollWidth / 2;
    }
    medir();
    window.addEventListener('resize', medir);

    function normalizar() {
      if (mitadAncho <= 0) return;
      pos = ((pos % mitadAncho) + mitadAncho) % mitadAncho;
    }

    function pintar() {
      track.style.transform = 'translateX(' + (-pos) + 'px)';
    }

    function pausarTemporal(ms) {
      pausadoHasta = performance.now() + ms;
    }

    riel.addEventListener('mouseenter', function () { pausadoHover = true; });
    riel.addEventListener('mouseleave', function () { pausadoHover = false; });
    riel.addEventListener('focusin', function () { pausadoHover = true; });
    riel.addEventListener('focusout', function () { pausadoHover = false; });

    function avanzarUnPaso(direccion) {
      var tarjeta = track.querySelector('[data-rk-rv-hijo]');
      var estilo = tarjeta ? getComputedStyle(track) : null;
      var espacio = estilo ? parseFloat(estilo.columnGap || estilo.gap || '24') : 24;
      var avance = tarjeta ? tarjeta.getBoundingClientRect().width + espacio : 300;
      pos += direccion * avance;
      normalizar();
      pintar();
      pausarTemporal(PAUSA_TRAS_INTERACCION);
    }

    var btnPrev = riel.querySelector('[data-rk-vit-prev]');
    var btnNext = riel.querySelector('[data-rk-vit-next]');
    if (btnPrev) btnPrev.addEventListener('click', function () { avanzarUnPaso(-1); });
    if (btnNext) btnNext.addEventListener('click', function () { avanzarUnPaso(1); });

    /* CADA TARJETA TIENE UN ENLACE A SANGRE (stretched link, rk-vit-card
       via CSS): sin esto, arrastrar el carrusel dispara ademas la
       navegacion de la tarjeta bajo el dedo al soltar, porque un click
       normal sigue al pointerup aunque hubo movimiento de por medio. Se
       mide el desplazamiento real y, si supera el umbral, se cancela el
       siguiente click con capture:true (una sola vez). */
    var UMBRAL_ARRASTRE = 6;
    var huboArrastreReal = false;
    function cancelarClicSiguiente(e) {
      e.preventDefault();
      e.stopPropagation();
      riel.removeEventListener('click', cancelarClicSiguiente, true);
    }

    /* SIN setPointerCapture EN pointerdown (14-09-2026): "no funcionan los
       botones... que se pueda llegar a cada producto". Capturar el puntero
       en CUALQUIER pointerdown — incluido un clic simple en "Ver producto",
       sin arrastre de por medio — hace que el navegador redirija tambien el
       click sintetico al contenedor que capturo (el riel), nunca al enlace
       que esta debajo. Verificado con un listener de diagnostico: el click
       llegaba con target=riel, jamas con target=boton, y el enlace no
       navegaba nunca. La captura ahora se pide recien cuando el movimiento
       ya cruzo el umbral de arrastre real — un clic sin desplazamiento no
       la activa, y el click sigue su camino normal hasta el <a>. */
    var pointerIdActivo = null;
    riel.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      arrastrando = true;
      huboArrastreReal = false;
      arrastreInicioX = e.clientX;
      arrastrePosInicio = pos;
      pointerIdActivo = e.pointerId;
    });
    riel.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      var delta = e.clientX - arrastreInicioX;
      if (Math.abs(delta) > UMBRAL_ARRASTRE) {
        if (!huboArrastreReal) {
          huboArrastreReal = true;
          riel.classList.add('rk-inh-vit__riel--arrastrando');
          if (pointerIdActivo !== null) {
            try { riel.setPointerCapture(pointerIdActivo); } catch (err) {}
          }
        }
      }
      if (!huboArrastreReal) return;
      pos = arrastrePosInicio - delta;
      normalizar();
      pintar();
    });
    function soltar() {
      if (!arrastrando) return;
      arrastrando = false;
      riel.classList.remove('rk-inh-vit__riel--arrastrando');
      pausarTemporal(PAUSA_TRAS_INTERACCION);
      if (huboArrastreReal) {
        riel.addEventListener('click', cancelarClicSiguiente, true);
      }
    }
    riel.addEventListener('pointerup', soltar);
    riel.addEventListener('pointercancel', soltar);
    riel.addEventListener('pointerleave', soltar);

    function cuadro(ts) {
      if (ultimoTs === null) ultimoTs = ts;
      var dt = ts - ultimoTs;
      ultimoTs = ts;
      var enPausa = arrastrando || pausadoHover || ts < pausadoHasta;
      if (!enPausa && VELOCIDAD > 0) {
        pos += VELOCIDAD * dt;
        normalizar();
        pintar();
      }
      requestAnimationFrame(cuadro);
    }
    requestAnimationFrame(cuadro);
  }

  function iniciarTodos() {
    document.querySelectorAll('[data-rk-vit-riel]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodos);
  } else {
    iniciarTodos();
  }
})();
